module.exports = __webpack_public_path__ + "img/jbgs.2e9ae8e8.png";